$(function () {
    $('#vertical-menu-btn').on('click', function (event) {
        let body = $('body');
        event.preventDefault();
        body.toggleClass('sidebar-enable');
        if ($(window).width() >= 992) {
            body.toggleClass('vertical-collpsed');
        } else {
            body.removeClass('vertical-collpsed');
        }
    });
})
